module.exports = __webpack_public_path__ + "static/media/Closed Captions Test-WDA Sample Video_1635057600753.defa74ad.vtt";